// One shared Google tag for optional GA4 and Ads destinations. No IDs in product copy.
export const CONSENT_EVENT = 'sporgmig:consent-changed';
const configured = new Set();
const sent = new Set();
let initialized = false;
const granted = key => { try { return localStorage.getItem(key) === 'granted'; } catch { return false; } };
export const hasAnalyticsConsent = () => granted('analytics_consent');
export const hasAdsConsent = () => granted('ads_consent');
const gaId = () => /^G-[A-Z0-9]+$/.test(process.env.REACT_APP_GA_MEASUREMENT_ID || '') ? process.env.REACT_APP_GA_MEASUREMENT_ID : '';
const adsId = () => /^AW-\d+$/.test(process.env.REACT_APP_GOOGLE_ADS_ID || '') ? process.env.REACT_APP_GOOGLE_ADS_ID : '';
const label = () => process.env.REACT_APP_GOOGLE_ADS_REQUEST_SUBMITTED_CONVERSION_LABEL || '';

export function updateGoogleConsent() {
  if (!window.gtag) return;
  window.gtag('consent', 'update', {
    analytics_storage: hasAnalyticsConsent() ? 'granted' : 'denied',
    ad_storage: hasAdsConsent() ? 'granted' : 'denied',
    ad_user_data: hasAdsConsent() ? 'granted' : 'denied',
    ad_personalization: 'denied',
  });
}

export function initializeGoogleTag() {
  const ids = [hasAnalyticsConsent() && gaId(), hasAdsConsent() && adsId()].filter(Boolean);
  if (!ids.length) { updateGoogleConsent(); return false; }
  if (!window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
  }
  if (!initialized) {
    window.gtag('consent', 'default', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    window.gtag('js', new Date());
    initialized = true;
  }
  updateGoogleConsent();
  for (const id of ids) if (!configured.has(id)) {
    window.gtag('config', id, { send_page_view: false, allow_ad_personalization_signals: false });
    configured.add(id);
  }
  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ids[0])}`;
    document.head.appendChild(script);
  }
  return true;
}

export function gaEvent(name, payload) {
  if (!hasAnalyticsConsent() || !gaId() || !initializeGoogleTag()) return;
  window.gtag('event', name, { ...payload, send_to: gaId() });
}

export function trackSubmittedRequestConversion(receipt) {
  if (!receipt?.id || receipt.ads_conversion_eligible !== true || receipt.is_demo || receipt.is_test
      || !hasAdsConsent() || !adsId() || !label()) return false;
  const key = `sporgmig_ads_request:${adsId()}:${label()}:${receipt.id}`;
  if (sent.has(key)) return false;
  try { if (localStorage.getItem(key)) return false; } catch { /* Google also deduplicates by request ID. */ }
  try {
    if (!initializeGoogleTag()) return false;
    window.gtag('event', 'conversion', { send_to: `${adsId()}/${label()}`, transaction_id: receipt.id });
  } catch { return false; } // Measurement must never interrupt a successful request.
  sent.add(key);
  try { localStorage.setItem(key, 'sent'); } catch { /* In-memory + Google deduplication still apply. */ }
  return true;
}

export function resetGoogleTagForTests() { configured.clear(); sent.clear(); initialized = false; }
